import * as React from "react";
import { SCORES_2ND_HALF } from "utils/constants";

const EventPickContext = React.createContext();

function eventPickReducer(state, action) {
  switch (action.type) {
    case "set1x2Event": {
      let outcomes = {
        1: {},
        2: {},
        3: {},
      };
      const boostMultiplier = (outcome) => (outcome.boost ? 2 : 1);

      const scoreRule = action.value.leagueData?.scoreRule;
      const eventData = action.value.eventData;
      if (action.value.eventPickData?.pick) {
        const pickedOutcome = action.value.eventPickData.pick;
        outcomes[pickedOutcome].predicted = true;
        if (action.value.eventPickData.boost) {
          outcomes[pickedOutcome].boost = true;
        }
      }
      if (scoreRule === 0) {
        outcomes[1].label = "1";
        outcomes[2].label = "X";
        outcomes[3].label = "2";
      } else {
        if (eventData?.predictable) {
          switch (scoreRule) {
            case 1:
              outcomes[1].label =
                eventData.homePoints * boostMultiplier(outcomes[1]) + "p";
              outcomes[2].label =
                eventData.drawPoints * boostMultiplier(outcomes[2]) + "p";
              outcomes[3].label =
                eventData.awayPoints * boostMultiplier(outcomes[3]) + "p";
              break;
            case 2:
              outcomes[1].label =
                eventData.homeOdds * boostMultiplier(outcomes[1]);
              outcomes[2].label =
                eventData.drawOdds * boostMultiplier(outcomes[2]);
              outcomes[3].label =
                eventData.awayOdds * boostMultiplier(outcomes[3]);
              break;
            default:
              break;
          }
        } else {
          outcomes[1].label = "-";
          outcomes[2].label = "-";
          outcomes[3].label = "-";
          outcomes[1].disabled = true;
          outcomes[2].disabled = true;
          outcomes[3].disabled = true;
        }
      }

      const result = action.value.eventData?.result;
      if (result !== undefined) {
        outcomes[result].isCorrectResult = true;
      }

      const isEventStarted =
        new Date(action.value.eventData?.startTime?.seconds * 1000) <
        new Date();

      const isEventSettled = action.value.eventData?.settled;
      const isCurrentRound =
        action.value.nextRoundId == action.value.currentRound?.id;

      //Disable all outcomes
      if (isEventStarted || isEventSettled || !isCurrentRound) {
        outcomes[1].disabled = true;
        outcomes[2].disabled = true;
        outcomes[3].disabled = true;
      }

      return {
        ...state,
        eventPick: action.value.eventPickData,
        isLoading: false,
        outcomes: outcomes,
        eventData: action.value.eventData,
      };
    }

    case "setLmsEvent": {
      let outcomes = {
        1: {},
        2: {},
        3: {},
      };

      if (action.value.eventPickData?.pick) {
        const pickedOutcome = action.value.eventPickData.pick;
        outcomes[pickedOutcome].predicted = true;
      }

      const eventData = action.value.eventData;
      const leagueUserData = action.value.leagueUserData;
      const homeTeam = eventData?.teams?.home;
      const awayTeam = eventData?.teams?.away;

      if (eventData) {
        outcomes[1].label = homeTeam?.name;
        outcomes[2].label = "X";
        outcomes[3].label = awayTeam?.name;

        outcomes[1].disabled =
          leagueUserData?.teams?.[homeTeam?.id]?.used &&
          leagueUserData?.teams?.[homeTeam?.id]?.settled;
        outcomes[3].disabled =
          leagueUserData?.teams?.[awayTeam?.id]?.used &&
          leagueUserData?.teams?.[awayTeam?.id]?.settled;
      }

      const result = action.value.eventData?.result;
      if (result !== undefined) {
        outcomes[result].isCorrectResult = true;
      }

      const isEventStarted =
        new Date(action.value.eventData?.startTime?.seconds * 1000) <
        new Date();

      const isEventSettled = action.value.eventData?.settled;
      const isCurrentRound =
        action.value.nextRoundId == action.value.currentRound?.id;

      //Disable all outcomes
      if (isEventStarted || isEventSettled || !isCurrentRound) {
        outcomes[1].disabled = true;
        outcomes[3].disabled = true;
      }

      return {
        ...state,
        eventPick: action.value.eventPickData,
        isLoading: false,
        outcomes: outcomes,
        eventData: action.value.eventData,
      };
    }

    case "setCorrectScoreEvent": {
      const outcomeCount = 6;

      const outcomes = {
        home: Object.fromEntries(
          Array.from({ length: outcomeCount }, (_, i) => [i.toString(), {}])
        ),
        away: Object.fromEntries(
          Array.from({ length: outcomeCount }, (_, i) => [i.toString(), {}])
        ),
      };

      const teamKeys = ["home", "away"];

      teamKeys.forEach((teamKey) => {
        outcomes[teamKey] = Object.keys(outcomes[teamKey]).reduce(
          (acc, key) => {
            let label;
            if (key == 5) {
              label = "5+";
            } else {
              label = key;
            }
            acc[key] = {
              ...outcomes[teamKey][key],
              label: label,
            };
            return acc;
          },
          {}
        );
      });

      let homeScorePicks = action.value.eventPickData?.homeScorePicks;
      let awayScorePicks = action.value.eventPickData?.awayScorePicks;

      if (homeScorePicks) {
        homeScorePicks.forEach((pick) => {
          outcomes.home[pick].predicted = true;
        });
      }

      if (awayScorePicks) {
        awayScorePicks.forEach((pick) => {
          outcomes.away[pick].predicted = true;
        });
      }

      const homeScore = action.value.eventData?.scores?.find(
        (x) =>
          x.type_id === SCORES_2ND_HALF &&
          x.participant_id === action.value.eventData?.teams?.home?.id
      )?.score?.goals;

      const awayScore = action.value.eventData?.scores?.find(
        (x) =>
          x.type_id === SCORES_2ND_HALF &&
          x.participant_id === action.value.eventData?.teams?.away?.id
      )?.score?.goals;

      if (homeScore !== undefined) {
        outcomes.home[homeScore].isCorrectResult = true;
      }
      if (awayScore !== undefined) {
        outcomes.away[awayScore].isCorrectResult = true;
      }

      let scoreRule = action.value.leagueData?.scoreRule;

      if (
        (awayScore !== undefined &&
          homeScore !== undefined &&
          scoreRule == 3) ||
        scoreRule == 4
      ) {
        let isHomeCorrect = homeScorePicks?.find((x) => x === homeScore);
        let isAwayCorrect = awayScorePicks?.find((x) => x === awayScore);

        if (!(isHomeCorrect !== undefined && isAwayCorrect !== undefined)) {
          if (outcomes.home[homeScore]) {
            outcomes.home[homeScore].isPartiallyCorrectResult = true;
          }
          if (outcomes.away[awayScore]) {
            outcomes.away[awayScore].isPartiallyCorrectResult = true;
          }
        }
      }

      const isEventStarted =
        new Date(action.value.eventData?.startTime?.seconds * 1000) <
        new Date();
      const isRoundStarted =
        new Date(action.value.currentRound?.deadline?.seconds * 1000) <
        new Date();
      const isCutoffGameType =
        action.value.leagueData?.gameTypeId == 5 ||
        action.value.leagueData?.gameTypeId == 9;
      const hasMaxPicksPerTeam = action.value.leagueData?.gameTypeId == 9;

      const isEventSettled = action.value.eventData?.settled;
      const isCurrentRound =
        action.value.nextRoundId == action.value.currentRound?.id;

      //Disable all outcomes
      if (
        isEventStarted ||
        isEventSettled ||
        !isCurrentRound ||
        (isCutoffGameType && isRoundStarted)
      ) {
        teamKeys.forEach((teamKey) => {
          outcomes[teamKey] = Object.keys(outcomes[teamKey]).reduce(
            (acc, key) => {
              acc[key] = {
                ...outcomes[teamKey][key],
                disabled: true,
              };
              return acc;
            },
            {}
          );
        });
      }

      //Disable other outcomes than the selected ones for a team
      const disableOutcomesExceptPicks = (outcomesObj, scorePicks) => {
        return Object.keys(outcomesObj).reduce((acc, key) => {
          acc[key] = {
            ...outcomesObj[key],
            disabled: !outcomesObj[key].predicted,
          };
          return acc;
        }, {});
      };
      if (hasMaxPicksPerTeam) {
        if (homeScorePicks && homeScorePicks.length > 2) {
          outcomes.home = disableOutcomesExceptPicks(
            outcomes.home,
            homeScorePicks
          );
        }

        if (awayScorePicks && awayScorePicks.length > 2) {
          outcomes.away = disableOutcomesExceptPicks(
            outcomes.away,
            awayScorePicks
          );
        }
      }

      return {
        ...state,
        eventPick: action.value.eventPickData,
        isLoading: false,
        outcomes: outcomes,
        eventData: action.value.eventData,
      };
    }
    case "setIsPlacingPrediction1x2": {
      let isPlacing = action.value.isPlacing;
      let outcome = action.value.outcome;

      const updatedOutcomes = Object.keys(state.outcomes).reduce((acc, key) => {
        acc[key] = {
          ...state.outcomes[key],
          disabled: isPlacing,
        };
        return acc;
      }, {});

      updatedOutcomes[outcome] = {
        ...updatedOutcomes[outcome],
        isPlacing: isPlacing,
      };

      return {
        ...state,
        outcomes: updatedOutcomes,
      };
    }

    case "setIsPlacingPredictionLMS": {
      let isPlacing = action.value.isPlacing;
      let outcome = action.value.outcome;

      const updatedOutcomes = Object.keys(state.outcomes).reduce((acc, key) => {
        acc[key] = {
          ...state.outcomes[key],
          disabled: isPlacing,
        };
        return acc;
      }, {});

      updatedOutcomes[outcome] = {
        ...updatedOutcomes[outcome],
        isPlacing: isPlacing,
      };

      return {
        ...state,
        outcomes: updatedOutcomes,
      };
    }
    case "setIsPlacingPredictionCS": {
      let isPlacing = action.value.isPlacing;
      let outcome = action.value.outcome;
      let home = action.value.home;

      const teamKey = home ? "home" : "away";

      const updatedOutcomes = {
        ...state.outcomes,
        [teamKey]: Object.keys(state.outcomes[teamKey]).reduce((acc, key) => {
          acc[key] = {
            ...state.outcomes[teamKey][key],
            disabled: isPlacing,
            isPlacing: key === outcome ? isPlacing : false,
          };
          return acc;
        }, {}),
      };

      return {
        ...state,
        outcomes: updatedOutcomes,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function EventPickProvider({ children }) {
  const [state, dispatch] = React.useReducer(eventPickReducer, {
    eventPick: undefined,
    eventData: undefined,
    isLoading: true,
    outcomes: [],
  });

  const value = { state, dispatch };
  return (
    <EventPickContext.Provider value={value}>
      {children}
    </EventPickContext.Provider>
  );
}

function useEventPick() {
  const context = React.useContext(EventPickContext);
  if (context === undefined) {
    throw new Error("useEvent must be used within a EventProvider");
  }
  return context;
}

export { EventPickProvider, useEventPick };
